import React, { useEffect, useState } from 'react'
import CommonHeader from '../../components/common-header'
import { getDashboardCount } from '../../api/list'
import { useNavigate } from 'react-router-dom'

const Dashboard = () => {

  const navigate = useNavigate()
  const definedAccess: any = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined;
  const parsedAccess = definedAccess ? JSON.parse(definedAccess) : { access: [] };
  const hasErrorQueues = parsedAccess.access.some((item: any) => item.module_name === 'Error Queues' && item.read_access === true);

  const [dashboardCount, setDashboardCount] = useState<any>([])
  const [countLoader, setCountLoader] = useState<boolean>(true)
  
  const handledashboardCount = async () => {
    try {
      const result = await getDashboardCount();
      if (result?.result) {
        setDashboardCount(result?.result?.data);
      }
      setCountLoader(false)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handledashboardCount()
  }, [])


  const Countcard = ({ category, count, pageLink = null, isUserInterface = false }:
     { category: string, count: number, pageLink?: string|null, isUserInterface?: boolean }) => {
    return (
      <div className={`rounded-[12px] shadow-md p-6 hover:shadow-lg  hover:hover:scale-105 transition-all duration-300 ${pageLink && hasErrorQueues ? "cursor-pointer" : ""}  ${isUserInterface ? "bg-[#C9E9ED] hover:bg-[#a9e1e8]" : " bg-white hover:bg-gray-50"}`} onClick={() => pageLink && hasErrorQueues && navigate(pageLink)}>
        <div className='flex items-center justify-between'>
          <h3 className={`text-lg font-semibold mb-1 ${pageLink && hasErrorQueues ? "cursor-pointer" : "cursor-default"}`}>{category}</h3>
          {countLoader ? (
            <div role="status">
            <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
          ) : (
            <p className="text-2xl font-normal">{count}</p>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px] h-[calc(100vh-100px)]">
      <div className="p-[16px] pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="Dashboard"
          description="Error queues and corresponding error counts."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <Countcard category="No Header" count={dashboardCount?.Header_not_found || 0} pageLink="/error-queues/no-header" isUserInterface={true} />
            {/* <Countcard category="DOS Mismatch" count={dashboardCount?.dos_mismatch || 0}
            pageLink="/error-queues/dos-mismatch" isUserInterface={true} /> */}
            <Countcard category="Duplicate Patient" count={dashboardCount?.overlap_dos || 0} pageLink="/error-queues/duplicate-patient" isUserInterface={true} />
            <Countcard category="No Location" count={dashboardCount?.Location_empty || 0} pageLink="/error-queues/no-location" isUserInterface={true} />
            {/* <Countcard category="Location Mismatch" 
            count={dashboardCount?.Location || 0}
             pageLink="/error-queues/location-mismatch" 
             isUserInterface={true} />
            <Countcard category="Information Missing"
             count={dashboardCount?.Data_missing || 0}
             pageLink="/error-queues/information-missing" 
             isUserInterface={true} />
            <Countcard category="Patient Not Found" 
            count={dashboardCount?.Patient || 0}
             pageLink="/error-queues/patient-not-found"
              isUserInterface={true} /> */}
            <Countcard category="Information Missing" count={dashboardCount?.information_mismatch_and_missing || 0} pageLink="/error-queues/information-missing" isUserInterface={true} />
            <Countcard category="Inbound eFax" count={dashboardCount?.Fax || 0} pageLink="/error-queues/inbound-efax" isUserInterface={false} />
            <Countcard category="Outbound eFax" count={dashboardCount?.virtual_fax || 0} pageLink="/error-queues/outbound-efax" isUserInterface={false} />
            <Countcard category="Parsing Error" count={dashboardCount?.Invalid_notes || 0} pageLink="/error-queues/parsing-error" isUserInterface={false} />
            {/* <Countcard category="Multiple Patient" count={dashboardCount?.Patient_multiple || 0} 
            pageLink="/error-queues/multiple-patient" isUserInterface={false} /> */}
            {/* <Countcard category="Source Mismatch" count={dashboardCount?.Missmatch_source_data || 0}
             pageLink="/error-queues/source-mismatch" isUserInterface={false} /> */}
            <Countcard category="API Error" count={dashboardCount?.API || 0} pageLink="/error-queues/api-error" isUserInterface={false} />
        </div>
      </div>
    </div>
  )
}

export default Dashboard

